var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { TAG_TYPES } from '../../types/TagTypes';
import { IDENTIFIERS } from '../../types/Identifiers';
import PROPS from '../../types/Props';
/**
 Here you can find more details about the implementation
 https://docs.google.com/document/d/1n-QE6LXncd_wqz9eQKufxMWnalE-WYxEzdrZ7rixF2A/edit#heading=h.8n2lir49tnp7
*/
export var EVENTS_PAGE = {
    tags: [
        {
            type: TAG_TYPES.TITLE,
            children: "{{event.name}} | {{site.name}}",
        },
        {
            type: TAG_TYPES.META,
            props: (_a = {},
                _a[PROPS.NAME] = 'description',
                _a[PROPS.CONTENT] = "{{event.seo.description}}",
                _a),
        },
        {
            type: TAG_TYPES.META,
            props: (_b = {},
                _b[PROPS.NAME] = 'robots',
                _b[PROPS.CONTENT] = 'index',
                _b),
        },
        {
            type: TAG_TYPES.META,
            props: (_c = {},
                _c[PROPS.PROPERTY] = 'og:title',
                _c[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}",
                _c),
        },
        {
            type: TAG_TYPES.META,
            props: (_d = {},
                _d[PROPS.PROPERTY] = 'og:description',
                _d[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}",
                _d),
        },
        {
            type: TAG_TYPES.META,
            props: (_e = {},
                _e[PROPS.PROPERTY] = 'og:image',
                _e[PROPS.CONTENT] = "{{event.main.image.url}}",
                _e),
        },
        {
            type: TAG_TYPES.META,
            props: (_f = {},
                _f[PROPS.PROPERTY] = 'og:image:width',
                _f[PROPS.CONTENT] = "{{event.image.width}}",
                _f),
        },
        {
            type: TAG_TYPES.META,
            props: (_g = {},
                _g[PROPS.PROPERTY] = 'og:image:height',
                _g[PROPS.CONTENT] = "{{event.image.height}}",
                _g),
        },
        {
            type: TAG_TYPES.META,
            props: (_h = {},
                _h[PROPS.PROPERTY] = 'og:site_name',
                _h[PROPS.CONTENT] = '{{site.name}}',
                _h),
        },
        {
            type: TAG_TYPES.META,
            props: (_j = {},
                _j[PROPS.PROPERTY] = 'og:type',
                _j[PROPS.CONTENT] = 'website',
                _j),
        },
        {
            type: TAG_TYPES.META,
            props: (_k = {},
                _k[PROPS.PROPERTY] = 'og:url',
                _k[PROPS.CONTENT] = "{{event.url}}",
                _k),
        },
        {
            type: TAG_TYPES.LINK,
            props: (_l = {},
                _l[PROPS.REL] = 'canonical',
                _l[PROPS.HREF] = "{{event.url}}",
                _l),
        },
        {
            type: TAG_TYPES.SCRIPT,
            props: (_m = {},
                _m[PROPS.TYPE] = 'application/ld+json',
                _m),
            disabled: "{{event.structured-data.disable-schema}}",
            children: "{{event.structured-data.render}}",
        },
    ],
};
